import React from 'react';
import propTypes from 'prop-types';
import { FormFeedback, Input } from 'reactstrap';

import { makeId } from 'utils/selectors';

import HelpIcon from './HelpIcon';

/**
 * render an array of values as a dropdown select input
 * @param {object} props - props passed to the component
 * @param {object} props.fieldContract - contract for field
 * @param {Array} props.fieldContract.allowedValues - allowed values
 * @param {string} props.fieldContract.helpText - help text
 * @param {string} props.fieldContract.name - contract field name
 * @param {boolean} props.fieldContract.required - is required boolean
 * @param {boolean} props.isReadonly - is read only boolean
 * @param {Function} props.onChange - on change function
 * @param {number} props.selectedValue - index of selected value
 * @param {string} props.updateLocation - location in contract to update
 * @param {string} props.validationMessage - validation message
 * @returns {React.Component} - Dropdown canvas widget
 */
const Dropdown = ({
  fieldContract: { allowedValues = [], helpText, name, required },
  isReadonly,
  onChange,
  selectedValue,
  updateLocation,
  validationMessage
}) => (
  <div className="d-flex flex-column my-3">
    <span className="d-flex align-items-center font-weight-bold mb-2">
      {`${name}${required ? '*' : ''}`}
      {helpText && <HelpIcon id={makeId({ updateLocation })} message={helpText} />}
    </span>
    <Input
      invalid={validationMessage}
      type="select"
      bsSize="sm"
      disabled={isReadonly}
      value={selectedValue}
      onChange={e => onChange(e.target.value)}
      data-test-id={makeId({ updateLocation })}
    >
      {allowedValues.map((displayName, ind) => (
        <option key={displayName} value={ind}>
          {displayName}
        </option>
      ))}
    </Input>
    <FormFeedback>{validationMessage}</FormFeedback>
  </div>
);

Dropdown.propTypes = {
  fieldContract: propTypes.shape({
    allowedValues: propTypes.arrayOf(
      propTypes.oneOfType([propTypes.string, propTypes.number])
    ),
    helpText: propTypes.string,
    name: propTypes.string,
    required: propTypes.bool
  }).isRequired,
  isReadonly: propTypes.bool,
  onChange: propTypes.func.isRequired,
  selectedValue: propTypes.oneOfType([propTypes.number, propTypes.array]).isRequired,
  updateLocation: propTypes.string.isRequired,
  validationMessage: propTypes.string
};

Dropdown.defaultProps = {
  isReadonly: false,
  validationMessage: undefined
};

export default Dropdown;
